import './index.css';

import axios from 'axios';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import App from './App';
import { createRequestInterceptor, createResponseInterceptor } from './axios/interceptors';
import reportWebVitals from './reportWebVitals';
import store from './store';

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
createRequestInterceptor();
createResponseInterceptor(store);

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
